// @flow

import { stripNonMatching } from '@tectonics/utils/formatting';

export function normalizeBrazilianDocument(documentValue: ?string): string {
  return documentValue ? stripNonMatching(documentValue, 'alphanumeric').toUpperCase() : '';
}
